<div class="cd-inline-notice" role="status" aria-live="polite">
  <div class="cd-inline-notice__indicator" aria-hidden="true">
    <cds-icon icon="action:megaphone" class="cd-inline-notice__indicator-icon"></cds-icon>
  </div>

  <div class="cd-inline-notice__content cd-inline-notice-content">
    <div class="cd-inline-notice__text-row">
      <div class="cd-inline-notice__text">
        <div class="cd-inline-notice__title-row">
          <span class="cds-body2-demibold cd-inline-notice__text-strong">{{ title }}</span>
        </div>
        @if (body) {
        <div class="cd-inline-notice__body-row">
          <span class="cds-body2">{{ body }}</span>
        </div>
        } @if (richBodyLines.length > 0) {
        <ul class="cd-inline-notice__list cd-inline-notice-list">
          @for (line of richBodyLines; track line) {
          <li class="cd-inline-notice__list-item">
            @if (hasRichBodyLineContent(line)) { @if (line.boldText) {
            <span class="cds-body2 cd-inline-notice__text-strong">{{ line.boldText }}</span>
            } @if (line.text) {
            <span class="cds-body2">{{ line.text }}</span>
            } @if (line.suffixText) {
            <span class="cds-body2">{{ line.suffixText }}</span>
            } }
          </li>
          }
        </ul>
        } @if (bodyLines.length > 0) {
        <ul class="cd-inline-notice__list cd-inline-notice-list">
          @for (line of bodyLines; track line) {
          <li class="cd-inline-notice__list-item">
            <span class="cds-body2">{{ line }}</span>
          </li>
          }
        </ul>
        }
      </div>

      @if (dismissible) {
      <button type="button" class="cd-inline-notice__dismiss" aria-label="Dismiss notice" (click)="onDismiss()">
        <cds-icon width="20px" height="20px" icon="action:cross"></cds-icon>
      </button>
      }
    </div>
  </div>
</div>
